export default __webpack_public_path__ + "static/backgroundContact--blurH-0b3b33553a3dde178c9fe21310d7d444.webp";